// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageTapBar_container_1aTKh","flag":"LanguageTapBar_flag_156nz","arrow":"LanguageTapBar_arrow_257qw","invertedColor":"LanguageTapBar_invertedColor_3esdo"};